import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useSessao } from './SessaoContext.jsx';

/**
 * Sem sessão, volta ao login.
 *
 * O `state` guarda para onde a pessoa estava indo, para que o login a
 * devolva ao lugar certo — e não sempre ao painel. Importa mais do que
 * parece: quem clicou num link de reserva e caiu no login
 * quer voltar para AQUELA reserva.
 *
 * Enquanto a sessão é verificada, nada é decidido. Redirecionar durante
 * o carregamento manda ao login quem tem sessão válida, num piscar de
 * tela a cada F5.
 */
export function RotaProtegida({ children }: { children: ReactNode }) {
  const { eu, carregando } = useSessao();
  const local = useLocation();

  if (carregando) return <TelaDeCarregamento />;
  // Caminho E query string: `/agenda?marcacao=…` sem o `?` perderia
  // justamente a reserva que a pessoa foi abrir.
  if (!eu) return <Navigate to="/login" replace state={{ de: local.pathname + local.search }} />;

  return <>{children}</>;
}

function TelaDeCarregamento() {
  return (
    <div className="login" aria-busy="true">
      <div className="login-box">
        <div className="mark" />
        <p>Carregando…</p>
      </div>
    </div>
  );
}
